<template>
    <div>
        <v-container grid-list-xl fluid>
            <DataTable :url="url" :enable-delete="false" descending :sortable="false"
                       :enable-edit="false" :enable-add="false" disable-search
                       :title="false" :titles="titles"
                       :fields-hidden-main="['updated_at']"
                       :formatter="formatters"></DataTable>
        </v-container>
    </div>
</template>

<script>
    import DataTable from '@/components/wasilni/DataTable';
    import moment from 'moment';
    import VWidget from "@/components/VWidget";

    export default {
        name: "Rides",
        components: {DataTable, VWidget},
        props: ['captain_id'],
        data() {
            return {
                url: '',
                titles: {
                    id: 'ID',
                    status: "Status",
                    datetime: "Datetime",
                    created_at: 'Created At',
                },
                loading: false,
                formatters: {
                    datetime(value) {
                        return moment(value).format('hh:mm A, DD MMM YYYY');
                    },
                    created_at(value) {
                        return moment(value).format('hh:mm A, DD MMM YYYY');
                    }
                },
            };
        },
        mounted() {
            this.url = `ride?captain_id=${this.captain_id}&filter=ALL`;
        }
    }
</script>

<style scoped>

</style>